import { isMicroServiceError } from '@/domains/core/httpClient/utils/isMicroServiceError';

export const getMicroServiceError = (error: unknown) => {
  if (isMicroServiceError(error)) {
    return (
      error?.response?.data.error.app_code ||
      error?.response?.data.error.appCode
    );
  }
  return null;
};
